import { merge } from 'lodash';
import { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
// material
import { useTheme, styled } from '@mui/material/styles';
import { Card, CardHeader, Stack, Box } from '@mui/material';
// utils
import { fNumber } from '../../../utils/formatNumber';
//
import { BaseOptionChart } from '../../charts';

// ----------------------------------------------------------------------





function AppCurrentVisits(props) {
  const [chartColors, setChartColors] = useState([]);
  useEffect(() => {
    if (props.patients.gender_categories.length === 1) {
      if (props.patients.gender_categories[0] == "Male")
        setChartColors(["#ff8533"]);
      else setChartColors(["#4f9ea9"]);
    } else {
      setChartColors(["#4f9ea9", "#ff8533"]);
    }
  }, [props.patients.gender_categories]);
  const CHART_DATAFemale = props.patients.gender_patients;
  const chartOptions = merge(BaseOptionChart(), {
    colors: chartColors,
    labels: props.patients.gender_categories,
    // stroke: { colors: [theme.palette.background.paper] },
    legend: { show: false},
    dataLabels: { enabled: true, dropShadow: { enabled: false } },
    tooltip: {
      marker: { show: false },
      y: {
        formatter: (seriesName) => fNumber(seriesName),
        title: {
          formatter: (seriesName) => `${seriesName}`
        }
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val.toFixed(0) + "%"
      },
    style: {
      fontSize: '15px',
      fontWeight: 'bold',
  },
          },
    plotOptions: {
      pie: {
      customScale: 1,
      donut: 
        { labels: { show: false },
          // customScale: 0.5
          size: 50 },
          expandOnClick: false,
          },
    chart: {
      brush: {
        enabled: true,
        target: 'GenderBar',
        autoScaleYaxis: false,
        id: 'GenderDonut',
        group: 'Gender'
      },
    },}
  });


  return (
    <Card  sx={{boxShadow: 'none', mt: 6}}>
            <Box sx={{ mx: 1 }} dir="ltr">
        <ReactApexChart type="donut" series={CHART_DATAFemale} options={chartOptions} height={300} />
        </Box>
    </Card>
  );
}

import { connect } from "react-redux";
const mapState = state => ({
  patients: state.overview.patients
 });
 
 const mapDispatch = ({ 
  overview: {loadData}}) => ({
    loadData: () => loadData()
 });
 
 export default connect(mapState, mapDispatch)(AppCurrentVisits);
